import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoTextBlock16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M14.2549 11.88C14.6001 11.88 14.8799 12.1598 14.8799 12.505C14.8799 12.8502 14.6001 13.13 14.2549 13.13H1.75488C1.4097 13.13 1.12988 12.8502 1.12988 12.505C1.12988 12.1598 1.4097 11.88 1.75488 11.88H14.2549ZM14.2549 8.88C14.6001 8.88 14.8799 9.15983 14.8799 9.505C14.8799 9.85018 14.6001 10.13 14.2549 10.13H1.75488C1.4097 10.13 1.12988 9.85018 1.12988 9.505C1.12988 9.15983 1.4097 8.88 1.75488 8.88H14.2549ZM14.2549 5.88C14.6001 5.88 14.8799 6.15983 14.8799 6.505C14.8799 6.85018 14.6001 7.13 14.2549 7.13H1.75488C1.4097 7.13 1.12988 6.85018 1.12988 6.505C1.12988 6.15983 1.4097 5.88 1.75488 5.88H14.2549ZM14.2549 2.88C14.6001 2.88 14.8799 3.15983 14.8799 3.505C14.8799 3.85018 14.6001 4.13 14.2549 4.13H1.75488C1.4097 4.13 1.12988 3.85018 1.12988 3.505C1.12988 3.15983 1.4097 2.88 1.75488 2.88H14.2549Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoTextBlock16;